<template>
  <div class="payment-amount">
    <div class="payment-amount__label">
      СУММА ПОПОЛНЕНИЯ
    </div>

    <v-text-field
      :value="displayValue"
      :disabled="disabled"
      outlined
      hide-details
      class="payment-amount__field"
      @input="onInput"
    />

    <div class="payment-amount__presets">
      <button
        v-for="preset in presets"
        :key="preset"
        type="button"
        class="payment-amount__preset"
        :class="{ 'payment-amount__preset_active': preset === value }"
        :disabled="disabled"
        @click="$emit('input', preset)"
      >
        {{ formatRubles(preset) }}
      </button>
    </div>
  </div>
</template>

<script>
  import { TOPUP_PRESETS } from '@/constants/billing'

  export default {
    name: 'AmountField',
    props: {
      // рубли
      value: {
        type: Number,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return { presets: TOPUP_PRESETS }
    },
    computed: {
      displayValue () {
        return this.value === null ? '' : this.value.toLocaleString('ru-RU')
      },
    },
    methods: {
      formatRubles (value) {
        return `${value.toLocaleString('ru-RU')} ₽`
      },
      onInput (raw) {
        const rubles = parseInt(String(raw).replace(/\D/g, ''), 10)
        this.$emit('input', Number.isNaN(rubles) ? null : rubles)
      },
    },
  }
</script>

<style lang="less" scoped>
.payment-amount {
  &__label {
    font-size: 12px;
    color: #949191;
    letter-spacing: 0.4px;
    margin-bottom: 8px;
  }

  &__field {
    // высоту держит слот, а не паддинги инпута — иначе поле распухает под кегль 28px
    ::v-deep .v-input__slot {
      min-height: 56px;
      background-color: #fff;
    }

    ::v-deep input {
      font-size: 28px;
      font-weight: 500;
      line-height: 36px;
      color: rgba(0, 0, 0, 0.87);
      // без потолка инпут тянет слот под кегль 28px и поле распухает вдвое
      max-height: 36px;
      padding: 0;
    }
  }

  &__presets {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 12px;
  }

  &__preset {
    // все пресеты держим одной строкой: минимум подобран под самый длинный «30 000 ₽»
    flex: 1 1 0;
    min-width: 72px;
    padding: 8px 6px;
    border-radius: 4px;
    background-color: #f1f3f6;
    color: rgba(0, 0, 0, 0.87);
    font-size: 13px;
    white-space: nowrap;
    transition: background-color 0.15s ease, color 0.15s ease;

    &:hover:not(:disabled) {
      background-color: #e4e8ee;
    }

    &:disabled {
      opacity: 0.5;
      cursor: default;
    }

    &_active,
    &_active:hover:not(:disabled) {
      background-color: @color-primary;
      color: #fff;
    }
  }
}
</style>
